import "./styles/main.scss";
import logoImg from "./assets/images/logo.svg";
import bgcurvymobileImg from "./assets/images/bg-curvy-mobile.svg";
import bgcurvydesktopImg from "./assets/images/bg-curvy-desktop.svg";
import illustrationIntroImg from "./assets/images/illustration-intro.png";
import iconAccessAnywhereImg from "./assets/images/icon-access-anywhere.svg";
import iconSecurityImg from "./assets/images/icon-security.svg";
import iconCollaborationImg from "./assets/images/icon-collaboration.svg";
import iconAnyFileImg from "./assets/images/icon-any-file.svg";
import illustrationStayProductiveImg from "./assets/images/illustration-stay-productive.png";
import iconArrowImg from "./assets/images/icon-arrow.svg";
import bgQuotesImg from "./assets/images/bg-quotes.png";
import profile1Img from "./assets/images/profile-1.jpg";
import profile2Img from "./assets/images/profile-2.jpg";
import profile3Img from "./assets/images/profile-3.jpg";
import iconLocationImg from "./assets/images/icon-location.svg";
import iconPhoneImg from "./assets/images/icon-phone.svg";
import iconEmailImg from "./assets/images/icon-email.svg";

document.addEventListener("DOMContentLoaded", function () {
  const curveMobile = document.getElementById("curveMobile");
  curveMobile.src = bgcurvymobileImg;

  const curveDesktop = document.getElementById("curveDesktop");
  curveDesktop.src = bgcurvydesktopImg;

  const logoImage = document.getElementById("logo");
  logoImage.src = logoImg;

  const logofooterImage = document.getElementById("logo-footer");
  logofooterImage.src = logoImg;

  const iconAccessAnywhere = document.getElementById("iconAccessAnywhere");
  iconAccessAnywhere.src = iconAccessAnywhereImg;

  const iconSecurity = document.getElementById("iconSecurity");
  iconSecurity.src = iconSecurityImg;

  const iconCollaboration = document.getElementById("iconCollaboration");
  iconCollaboration.src = iconCollaborationImg;

  const iconAnyFile = document.getElementById("iconAnyFile");
  iconAnyFile.src = iconAnyFileImg;

  const illustrationStayProductive = document.getElementById(
    "illustrationStayProductive"
  );
  illustrationStayProductive.src = illustrationStayProductiveImg;

  const iconArrow = document.getElementById("iconArrow");
  iconArrow.src = iconArrowImg;

  const bgQuotes = document.getElementById("bgQuotes");
  bgQuotes.src = bgQuotesImg;

  const illustrationIntro = document.getElementById("illustrationIntro");
  illustrationIntro.src = illustrationIntroImg;

  const profile1 = document.getElementById("profile1");
  profile1.src = profile1Img;

  const profile2 = document.getElementById("profile2");
  profile2.src = profile2Img;

  const profile3 = document.getElementById("profile3");
  profile3.src = profile3Img;

  const iconLocation = document.getElementById("iconLocation");
  iconLocation.src = iconLocationImg;

  const iconPhone = document.getElementById("iconPhone");
  iconPhone.src = iconPhoneImg;

  const iconEmail = document.getElementById("iconEmail");
  iconEmail.src = iconEmailImg;

});

if (module.hot) {
  module.hot.accept();
}
